import ProfileParams from '@root/auto-pricing/src/models/profile-params';
import PropTypes from '@root/vendor/prop-types';
import QuotesContext from '@root/quotes/src/models/quotes-context';
import UnderwritingPendingEntry from '@root/quotes/src/components/underwriting-pending-entry';

export default function BindUnderwritingPending({
  profileParams,
  quotesContext,
}) {
  const analyticsContext = 'BIND_UNDERWRITING_PENDING';

  return (
    <UnderwritingPendingEntry
      analyticsContext={analyticsContext}
      profileParams={profileParams}
      quotesContext={quotesContext}
    />
  );
}

BindUnderwritingPending.propTypes = {
  profileParams: PropTypes.instanceOf(ProfileParams).isRequired,
  quotesContext: PropTypes.instanceOf(QuotesContext).isRequired,
};
